module.exports =
  data: ->
    tag_options: [value: null, text: 'Carregando...']

  methods:
    loadTagsOptions: ->
      company_id = Session?.current_company?.id
      new TagsResource().index(@loadTagsOptionsSuccess, null, params: {company_id: company_id})

    getTagsFromStore: ->
      # Busca as tags no central store
      data = { tags: @$store.getters.tagsList }
      @loadTagsOptionsSuccess data

    loadTagsOptionsSuccess: (data) ->
      tag_options = for tag in data.tags
        { value: { contact_tags_tag_id_eq: tag.id.toString() }, text: tag.name }
      tag_options.unshift(value: null, text: 'Tags')
      @tag_options = tag_options

      # Commita as mudanças para o state do central store
      @$store.commit 'loadTags', data.tags if @load_tags && data.tags 

  computed:
    load_tags: ->
      @$store.getters.tagsCount == 0

  created: ->
    if @load_tags
      @loadTagsOptions()
    else
      @getTagsFromStore()



// WEBPACK FOOTER //
// ./src/mixins/tags_options.coffee